import {
  QualityData,
  Ratings,
  RatingsChart,
  Comments,
} from 'data/types/quality';

const normalizeReferenceLine = (data: RatingsChart[]) => {
  const counts = data.map((item: RatingsChart) => {
    return item.aggRating;
  });
  const sum = counts.reduce((previous, current) => {
    return current + previous;
  });
  const avg = sum / counts.length;
  return avg;
};

const normalizeRatings = (data: Ratings) => ({
  integration: data.integration,
  count: data.count,
  stars: data.stars,
  change: data.change,
});

const normalizeRatingsChart = (data: RatingsChart) => ({
  xAxis: data.date,
  yAxis: data.aggRating,
});

const normalizeComments = (data: Comments) => ({
  name: data.name,
  date: data.date,
  rating: data.rating,
  commentText: data.commentText,
  integration: data.integration,
  orderId: data.orderId,
});

export const normalizeQuality = (data: QualityData) => ({
  updatedAt: data.updatedAt,
  ratings: data.ratings.map(normalizeRatings),
  referenceLine: normalizeReferenceLine(data.ratingsChart),
  ratingsChart: data.ratingsChart.map(normalizeRatingsChart),
  comments: data.comments.map(normalizeComments),
});

export type Quality = ReturnType<typeof normalizeQuality>;
